import { render } from "./FolderNameInput.vue?vue&type=template&id=6c23652a&ts=true"
import script from "./FolderNameInput.vue?vue&type=script&lang=ts"
export * from "./FolderNameInput.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1502261522/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__